import { combineReducers } from '@reduxjs/toolkit'
import cartProducts from './productsSlice'

const reducer = combineReducers({
    cartProducts,
})

export default reducer
